import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { AuthProvider, useAuth } from './lib/auth.js';
import { RouteGuard } from './components/RouteGuard.js';

/**
 * `/` mostra Dashboard pra quem tem acesso (founder/admin).
 * Pra quem não tem (Patricia / support_l1), redireciona pro landingRoute do role.
 * Evita cair na tela "Acesso restrito" só por chegar na raiz.
 */
function HomeRoute(): JSX.Element {
  const { user, canAccessRoute } = useAuth();
  if (user && !canAccessRoute('/')) {
    return <Navigate to={user.landingRoute ?? '/meu-trabalho'} replace />;
  }
  return <Dashboard />;
}
import { Login } from './routes/Login.js';
import { Dashboard } from './routes/Dashboard.js';
import { Contacts } from './routes/Contacts.js';
import { ContactDetail } from './routes/ContactDetail.js';
import { Inbox } from './routes/Inbox.js';
import { Pipeline } from './routes/Pipeline.js';
import { Vendas } from './routes/Vendas.js';
import { VendaDetail } from './routes/VendaDetail.js';
import { Financeiro } from './routes/Financeiro.js';
import { LedgerDetail } from './routes/LedgerDetail.js';
import { Trafego } from './routes/Trafego.js';
import { CampanhaDetail } from './routes/CampanhaDetail.js';
import { Equipe } from './routes/Equipe.js';
import { EquipeDetail } from './routes/EquipeDetail.js';
import { Recuperacao } from './routes/Recuperacao.js';
import { MeuTrabalho } from './routes/MeuTrabalho.js';
import { MinhasComissoes } from './routes/MinhasComissoes.js';
import { Operacoes } from './routes/Operacoes.js';
import { Funil } from './routes/Funil.js';
import { Configuracoes } from './routes/Configuracoes.js';
import { WhatsApp } from './routes/WhatsApp.js';
import { OperacaoReal } from './routes/OperacaoReal.js';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/operacao" element={<OperacaoReal />} />
          <Route
            element={
              <RouteGuard>
                <Layout />
              </RouteGuard>
            }
          >
          <Route path="/" element={<HomeRoute />} />
          <Route path="/contatos" element={<Contacts />} />
          <Route path="/contatos/:id" element={<ContactDetail />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/recuperacao" element={<Recuperacao />} />
          <Route path="/meu-trabalho" element={<MeuTrabalho />} />
          <Route path="/minhas-comissoes" element={<MinhasComissoes />} />
          <Route path="/vendas" element={<Vendas />} />
          <Route path="/vendas/:id" element={<VendaDetail />} />
          <Route path="/financeiro" element={<Financeiro />} />
          <Route path="/financeiro/ledger/:id" element={<LedgerDetail />} />
          <Route path="/trafego" element={<Trafego />} />
          <Route path="/trafego/campanha/:campaign" element={<CampanhaDetail />} />
          <Route path="/equipe" element={<Equipe />} />
          <Route path="/equipe/:id" element={<EquipeDetail />} />
          <Route path="/operacoes" element={<Operacoes />} />
          <Route path="/funil" element={<Funil />} />
          <Route path="/configuracoes" element={<Configuracoes />} />
          <Route path="/configuracoes/whatsapp" element={<WhatsApp />} />
          <Route
            path="*"
            element={
              <div className="p-12 text-center">
                <h2 className="text-xl font-bold">404</h2>
                <p className="text-muted-foreground mt-2">Página não encontrada</p>
              </div>
            }
          />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
